export const getListItems = (tags: Array<tagT>) =>
  (tags || []).map((tag) => ({ id: tag.id, value: tag.name, name: tag.name }));

export const getListItemsFromString = (tagsName: Array<tagT>) =>
  (tagsName || []).map((tagName) => ({
    id: tagName,
    value: tagName,
    name: tagName,
  }));
